import React from 'react';
import {resolveAuthMode} from '../../auth/authMode';
import Resource from '../../core/serverresource';
import {AdfsUserInfo} from './adfs/AdfsUserInfo';
import {EntraIdUserInfo} from './entraid/EntraIdUserInfo';

export interface UserInfoProps {
    fullName?: string | null;
    onToggleDebug: () => void;
}

export const UserInfo = ({fullName, onToggleDebug}: UserInfoProps): JSX.Element => {
    const mode = resolveAuthMode({
        storage: window.sessionStorage,
        searchParams: new URLSearchParams(window.location.search),
        isEntraIdForced: Resource.isEntraIdForced(),
    });

    return mode === 'entra-id'
        ? <EntraIdUserInfo fullName={fullName} onToggleDebug={onToggleDebug}/>
        : <AdfsUserInfo fullName={fullName} onToggleDebug={onToggleDebug}/>;
};
